import Holidays from "date-holidays";
import moment from "moment";
import { federalBankHolyDays } from "../pages/DrawRequests/data/holydays";


type BillingDates = {
    dueBy: string[];
    invoicesBy: string[];
};

const dateFormat = 'MM/DD/YYYY'
const now = moment();
const hd = new Holidays("US");



const formatToUSA = (value: string) => {
    const arrayDate: string[] = value.split('-')
    return `${arrayDate[1]}/${arrayDate[2]}/${arrayDate[0]}`
};


//holly days this year
const holidays: string[] = hd
    .getHolidays(now.year())
    .filter((holy) => federalBankHolyDays.includes(holy.name))
    .map((holy: any) => {
        return formatToUSA(holy.date.split(" ")[0]);
    });
//holly days next year
const holidaysNextYear: string[] = hd
    .getHolidays(now.year() + 1)
    .filter((holy) => federalBankHolyDays.includes(holy.name))
    .map((holy: any) => {
        return formatToUSA(holy.date.split(" ")[0]);
    });

const getDateNoInHolyDay = (date: moment.Moment) => {
    let finalDate = date

    while (
        finalDate.day() === 0 ||
        finalDate.day() === 6 ||
        holidays.includes(finalDate.format(dateFormat))
        || holidaysNextYear.includes(finalDate.format(dateFormat))
    ) {
        finalDate = finalDate.subtract(1, 'day')
    }

    return finalDate
};


const buildDates = (date: moment.Moment) => {
    const endOfMonth = date.clone().endOf("month");
    const lastDay = endOfMonth.date();
    const midDay = Math.floor(lastDay / 2);

    const mid = date.clone().date(midDay);
    const end = endOfMonth.clone();

    const realMid = getDateNoInHolyDay(mid);
    const realEnd = getDateNoInHolyDay(end);
    return [realMid, realEnd];
};

const generateBillingDates = (): BillingDates => {

    const thisMonth = buildDates(now);
    const nextMonth = buildDates(now.clone().add(1, "month"));

    const dueMoments = [...thisMonth, ...nextMonth];

    const dueBy = dueMoments.map(d => d.format(dateFormat));

    const invoicesBy = dueMoments.map(d =>
        d.clone().subtract(7, "days").format(dateFormat)
    );

    return { invoicesBy, dueBy };
}

const { invoicesBy, dueBy } = generateBillingDates()




export const getDueDateForCheck = () => {
    const currentDate = moment();
    const invoicesByIndex = invoicesBy.findIndex(date => currentDate.isBefore(moment(date, dateFormat, true)))

    if (invoicesByIndex === -1) return currentDate
    return moment(dueBy[invoicesByIndex]!, dateFormat, true)

};


